import React, { useEffect } from 'react'
import { Link } from 'react-router-dom'

export default function TermsOfService() {
  useEffect(() => {
    window.scrollTo(0, 0)
  }, [])

  return (
    <div className="min-h-screen bg-gradient-to-br from-gray-900 via-black to-gray-900">
      <header className="fixed top-0 w-full bg-black/50 backdrop-blur-md border-b border-gray-800">
        <nav className="container mx-auto px-4 py-4 flex justify-between items-center">
          <Link to="/" className="text-2xl font-bold bg-gradient-to-r from-purple-400 to-pink-600 text-transparent bg-clip-text">
            Verdyct
          </Link>
        </nav>
      </header>
      <main className="container mx-auto px-4 pt-32 pb-20">
        <div className="max-w-4xl mx-auto">
          <h1 className="text-4xl font-bold mb-8 bg-gradient-to-r from-purple-400 to-pink-600 text-transparent bg-clip-text">Terms of Service</h1>
          
          <div className="space-y-6 text-gray-300">
            <section>
              <h2 className="text-2xl font-semibold text-white mb-4">1. Terms</h2>
              <p>By accessing Verdyct, you agree to be bound by these terms of service. The Service is intended for users who are at least 13 years of age.</p>
            </section>

            <section>
              <h2 className="text-2xl font-semibold text-white mb-4">2. Use License</h2>
              <p>We grant you a limited, non-exclusive, non-transferable license to use Verdyct for personal or business purposes in accordance with these Terms.</p>
            </section>

            <section>
              <h2 className="text-2xl font-semibold text-white mb-4">3. Service Description</h2>
              <p>Verdyct provides an AI-powered debate platform where two AI agents discuss topics and present different viewpoints. The service includes both free and premium features.</p>
            </section>

            <section>
              <h2 className="text-2xl font-semibold text-white mb-4">4. User Obligations</h2>
              <ul className="list-disc pl-6 space-y-2">
                <li>You must provide accurate information when creating an account</li>
                <li>You are responsible for maintaining the security of your account</li>
                <li>You agree not to use the service for any illegal or unauthorized purpose</li>
                <li>You must not attempt to manipulate or abuse the AI debate system</li>
              </ul>
            </section>

            <section>
              <h2 className="text-2xl font-semibold text-white mb-4">5. Content Policy</h2>
              <p>You retain ownership of any content you submit through the Service. However, you grant us a license to use, store, and share your content as necessary to provide the Service.</p>
            </section>

            <section>
              <h2 className="text-2xl font-semibold text-white mb-4">6. Limitations</h2>
              <p>The Service is provided "as is" without warranties. We are not responsible for the accuracy of AI-generated content and debate outcomes.</p>
            </section>

            <section>
              <h2 className="text-2xl font-semibold text-white mb-4">7. Changes to Terms</h2>
              <p>We reserve the right to modify these terms at any time. We will notify users of any material changes.</p>
            </section>
          </div>
        </div>
      </main>
    </div>
  )
}